import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import PlayerCard from './PlayerCard'; 

function DraggablePlayerCard({ player, isInSlot, order, position }) {
  // 슬롯 안의 카드 (스왑 대상)는 slot-O번 ID를 사용하고,
  // 후보 카드 (배치 대상)는 card-선수명+포지션 ID를 사용하여 명확히 구분
  const id = isInSlot ? `slot-${order}` : `card-${player.playerName}-${player.position}`;
  
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: id, 
    data: { 
      type: 'PlayerCard', 
      playerData: position, // 드래그되는 선수의 position key (예: C, 1B, CF 등)
      order: order          // 슬롯 안에 있을 경우 타순 정보 (예: 1번, 2번 등)
    },
  });

  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
    zIndex: 20, 
    touchAction: 'none',
    userSelect: 'none',
  } : {
    touchAction: 'none',
    userSelect: 'none',
  };

  return (
    <div 
      ref={setNodeRef} 
      style={style} 
      {...listeners} 
      {...attributes}
    >
      <PlayerCard player={player}/>
    </div>
  );
}

export default DraggablePlayerCard;